export default __webpack_public_path__ + "static/media/weights.837ae71a.png";